import { combineReducers } from 'redux';

import downloadsProductsReducer from '../products/store/reducers';
import downloadsDocumentsReducer from '../documents/store/reducers';

export default combineReducers({
  products: downloadsProductsReducer,
  documents: downloadsDocumentsReducer,
});
